import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Emit } from 'vue-property-decorator';
import apis from '@/apis/personal';
import eitsApi from '@/apis/eitsApiWithHttp';
import { validateor } from '@/utils/validate';
import { pwdHashEncryptVerify } from '@/utils/index';

var ApproveDialog = /*#__PURE__*/function (_Vue) {
  _inherits(ApproveDialog, _Vue);

  var _super = _createSuper(ApproveDialog);

  function ApproveDialog() {
    var _this;

    _classCallCheck(this, ApproveDialog);

    _this = _super.apply(this, arguments);
    _this.phoneNoForm = {
      phoneNo: ''
    };
    _this.verifyCodeForm = {
      verifyCode: '',
      oldPwd: ''
    };
    _this.phoneDialogTitle = '';
    _this.btnTxt = '发送验证码';
    _this.btnFlag = false;
    _this.showPhoneDialog = false;
    _this.isShowPwd = false;
    _this.interval = null;
    _this.phoneCheckType = 0;
    _this.phoneCheck = '';
    _this.rules = {
      phoneNo: validateor({
        required: true,
        type: 'mobile',
        trigger: 'blur'
      }),
      verifyCode: validateor({
        required: true,
        trigger: 'blur'
      }),
      oldPwd: validateor({
        required: true,
        trigger: 'blur'
      })
    };
    return _this;
  }

  _createClass(ApproveDialog, [{
    key: "approveSuccess",
    value: function approveSuccess() {}
  }, {
    key: "onMouseClick",
    value: function onMouseClick(ev) {
      this.isShowPwd = ev.target.className.indexOf('h-icon-password_unvisible') > -1;
    }
  }, {
    key: "closePhoneDialog",
    value: function closePhoneDialog() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }

      this.showPhoneDialog = false;
      this.resetPhoneDialog();
      this.btnTxt = '发送验证码';
      this.btnFlag = false;
    }
  }, {
    key: "resetPhoneDialog",
    value: function resetPhoneDialog() {
      this.$refs.phoneNoForm.resetFields();
      this.$refs.phoneNoForm.resetValidates();
      this.$refs.verifyCodeForm.resetFields();
      this.$refs.verifyCodeForm.resetValidates();
    }
  }, {
    key: "getChallengeCode",
    value: function getChallengeCode() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        eitsApi.CHALLENGE_CODE_SDK({
          name: _this2.$store.getters.userInfo.userName,
          productCode: process.env.VUE_APP_PRODUCTCODE,
          type: 1
        }).then(function (res) {
          var _res$data = res.data,
              codeId = _res$data.codeId,
              salt = _res$data.salt,
              vCode = _res$data.vCode;
          resolve({
            codeId: codeId,
            salt: salt,
            vCode: vCode
          });
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "updatePhoneNo",
    value: function updatePhoneNo() {
      var _this3 = this;

      this.$refs.verifyCodeForm.validate(function (valid) {
        if (valid) {
          _this3.getChallengeCode().then(function (data) {
            var codeId = data.codeId,
                salt = data.salt,
                vCode = data.vCode;
            apis.checkUserVerifyCode({
              codeId: codeId,
              phoneNo: _this3.phoneNoForm.phoneNo,
              oldPwd: pwdHashEncryptVerify(_this3.verifyCodeForm.oldPwd, salt, vCode),
              verifyCode: _this3.verifyCodeForm.verifyCode
            }).then(function (res) {
              var msg = _this3.phoneCheckType === 0 ? '修改成功' : '认证成功';

              if (res.type === -1) {
                _this3.$message.error(res.msg);
              } else {
                _this3.showPhoneDialog = false;

                _this3.approveSuccess();

                _this3.$message.success(msg);

                _this3.resetPhoneDialog();
              }
            }).catch(function (err) {
              console.log(err);
            });
          });

          return true;
        }

        return false;
      });
    }
  }, {
    key: "toCheckPhoneNo",
    value: function toCheckPhoneNo(type) {
      this.phoneCheckType = type;
      this.showPhoneDialog = true;

      if (type === 1) {
        this.phoneDialogTitle = '认证手机号码';
      } else {
        this.phoneNoForm.phoneNo = '';
        this.phoneDialogTitle = '修改手机号码';
      }
    }
  }, {
    key: "sendCode",
    value: function sendCode() {
      var _this4 = this;

      this.$refs.phoneNoForm.validate(function (valid) {
        if (valid) {
          apis.getUserVerifyCode({
            phoneNo: _this4.phoneNoForm.phoneNo
          }).then(function (res) {
            _this4.handleTimer();

            _this4.$message.success('发送成功');
          }).catch(function (err) {});
        }
      });
    }
  }, {
    key: "handleTimer",
    value: function handleTimer() {
      var _this5 = this;

      var num = 60;
      var interval = setInterval(function () {
        _this5.interval = interval;
        num--;
        _this5.btnTxt = "".concat(num, "\u79D2\u540E\u91CD\u65B0\u83B7\u53D6");
        _this5.btnFlag = true;

        if (num <= 1) {
          _this5.btnFlag = false;
          _this5.btnTxt = '重新获取验证码';
          num = 60;
          clearInterval(interval);
          _this5.interval = null;
        }
      }, 1000);
    }
  }]);

  return ApproveDialog;
}(Vue);

__decorate([Emit('approveSuccess')], ApproveDialog.prototype, "approveSuccess", null);

ApproveDialog = __decorate([Component], ApproveDialog);
export default ApproveDialog;